import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    value = value || '';
    if (/[^\d()+\- ]+/.test(value)) {
      // Invalid characters in input - return as is.
      return value.toString().trim();
    }
    value = value.replace(/\D+/g, '').trim();
    if (!value) {
      return '';
    }
    if (value.length < 7 || value.length > 15) {
      // Invalid number of digits - return as is.
      return value;
    }
    let country = '';
    let area = '';
    let prefix = '';
    let number = '';
    switch (value.length) {
      case 7:   // ###-####
        prefix = value.substr(0, 3);
        number = value.substr(3);
        return `${prefix}-${number}`;
      case 8:
      case 9:
        // Invalid number of digits - return as is.
        return value;
      case 10:  // (###) ###-####
        area = value.substr(0, 3);
        prefix = value.substr(3, 3);
        number = value.substr(6);
        return `(${area}) ${prefix}-${number}`;
      case 11:  // +# (###) ###-####
        country = value.substr(0, 1);
        area = value.substr(1, 3);
        prefix = value.substr(4, 3);
        number = value.substr(7);
        if (country === '1') {
          return `(${area}) ${prefix}-${number}`;
        }
        return `+${country} (${area}) ${prefix}-${number}`;
      case 12:
      case 13:
      case 14:
      case 15:
        // International phone number. Local formatting rules vary wildly, so the best we can do is format it as E.164
        // (plus sign, followed by the number with no spaces, dashes, or other formatting marks)
        return '+' + value;
    }
  }
}
